import React, { useEffect, useState } from 'react';
import { ClientOrderHeaderContainer } from '../../../components/clientPortal/clientOrderHeader/ClientOrderHeaderContainer';
import { Grid, SpaceWrapper } from '../../../ui-toolkit';
import { ClientCancelOrderContainer } from './ClientCancelOrderContainer';
import { useParams } from 'react-router-dom';
import { getClientOrderAction } from '../../../store/clientPortal/clientOrderSlice';
import { useAppDispatch } from '../../../store/store';
import { useKeyToSelect } from '../../../store/createKeyedDataAsyncSlice';
import { RootStore } from '../../../store/types';
import { CancelOrderButtonBlock } from '../../../components/clientPortal/orderOverview/CancelOrderButtonBlock';
import { ClientCommentsContainer } from './ClientCommentsContainer';
import { ClientDocumentsContainer } from './ClientDocumentsContainer';
import { ClientSigningContainer } from './ClientSigningContainer';
import { eExternalOrderStatus } from '../../../ui-toolkit/enums/eExternalOrderStatus';

export const ClientOrderOverviewContainer: React.FC = () => {
  const [showCancelOrderDialog, setShowCancelOrderDialog] = useState(false);
  const { orderId } = useParams<{ orderId: string }>();
  const dispatch = useAppDispatch();

  // given that the ClientOrderApp is always at the top, I suppose we could *just* have the selector.
  // but, this creates a kind of dependency, so I'll retain it until we have RTK Query (or an alternate solution) up and running.
  useEffect(() => {
    dispatch(getClientOrderAction(orderId));
  }, [dispatch, orderId]);

  const { data: orderData } = useKeyToSelect(orderId, ({ clientPortal }: RootStore) => clientPortal.clientOrder);

  return (
    <>
      <ClientOrderHeaderContainer>
        <CancelOrderButtonBlock
          onCancelButtonClick={() => setShowCancelOrderDialog(true)}
          orderCancelled={orderData?.orderStatus === eExternalOrderStatus.cancelled}
        />
      </ClientOrderHeaderContainer>
      <SpaceWrapper>
        <Grid columnCount={2}>
          <Grid>
            <ClientSigningContainer />
            <ClientDocumentsContainer />
          </Grid>
          <ClientCommentsContainer />
        </Grid>
      </SpaceWrapper>
      {showCancelOrderDialog && (
        <ClientCancelOrderContainer
          orderId={orderId}
          orderStatus={orderData?.orderStatus}
          setShowCancelOrderDialog={setShowCancelOrderDialog}
        />
      )}
    </>
  );
};
